const defineLocalStorageKey = (key: string) => `turo-${key}`;

export const LS_AUTH_TOKEN = defineLocalStorageKey('auth-user');
